import { AuthenticationMode, tenantSettings } from "./tenantSettings";

export const getScormAccessTokenFromSessionStorage = () => {
    if (tenantSettings.customConfig.useGatewayScopesAsScormScopes) {
        var key = Object.keys(window.sessionStorage).find(k => k.includes("accesstoken") && k.includes(tenantSettings.customConfig.api.scopes[0]));
    } else {
        var key = Object.keys(window.sessionStorage).find(k => k.includes("accesstoken") && k.includes(tenantSettings.customConfig.scormApiScopes[0]));
    }
    const token = JSON.parse(window.sessionStorage.getItem(key)).secret;
    return token; 
}